import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { changeDefaultColor, changeDefaultNumber } from "../../../../store/tool";
import ColorInput from "../../../Palettes/Propertybar/input/colorInput";
import NumberInput from "../../../Palettes/Propertybar/input/numberInput";

const PolygonDefaultProperyPalette = ({ polygon }: { polygon: GeometricShape }) => {
  const dispatch = useAppDispatch();
  const definitionStrokeColor = useAppSelector(state => state.tool.toolSettings.polygon.current.stroke)
  const definitionFillColor = useAppSelector(state => state.tool.toolSettings.polygon.current.fill)
  const definitionLineWeight = useAppSelector(state => state.tool.toolSettings.polygon.current.strokeWidth)
  return (
    <>
      <div className="property__element">
        <ColorInput
          properyDisplayName={"Stroke color"}
          currentValue={definitionStrokeColor as ColorValue}
          setValue={(input: ColorValue) => {
            console.log(input);

            const actionPayload = {
              id: "polygon",
              propertyValue: input,
              propertyName: "stroke",
            };
            dispatch(changeDefaultColor(actionPayload));
          }}
        />
      </div>
      <div className="property__element">
        <ColorInput
          properyDisplayName={"Fill color"}
          currentValue={definitionFillColor as ColorValue}
          setValue={(input: ColorValue) => {
            console.log(input);

            const actionPayload = {
              id: "polygon",
              propertyValue: input,
              propertyName: "fill",
            };
            dispatch(changeDefaultColor(actionPayload));
          }}
        />
      </div>
      <div className="property__element">
        <NumberInput
          propertyDisplayName="Line weight"
          currentValue={definitionLineWeight ?? 1}
          setValue={(number) => {
            const payload = {
              id: "polygon",
              propertyValue: number,
              propertyName: "strokeWidth",
            };
            dispatch(changeDefaultNumber(payload));
          }}
        ></NumberInput>
      </div>
    </>)
};
const createDefaultPropertyPalette = (polygon: GeometricShape) => {
  return <PolygonDefaultProperyPalette polygon={polygon} />;
};
export default createDefaultPropertyPalette;
